import { useReducer } from 'react';

export default function useTopReducer() {
  const [top, dispatchTop] = useReducer(
    (data, action) => ({ ...data, ...action }),
    {
      status: 'ARMED',
      dataSource: 'LIVE',
      brokerage: 'none',
      accountNumber: 'none',
      goLong: false,
      goShort: false,
      workOrders: false,
      workOrdersOnEntry: true,
      workOrdersOnExit: true,
      quantityBasis: 'none',
      strategy: 'BASIC_TRADING_SYSTEM',
      instrument: 'none',
      symbol: '',
      startPeriod: 'open',
      //optionChoices: [],
      setup: 'none',
      terminateWhenFlat: true,
      restartSystemOncePositionHasFlattened: false,
      flattenAtMarketClose: false,
      getAwayOffsetPct: 0.1,
      pctBetweenBidAsk: 0.5,
      pctIncreasePerOrderAttempt: 0.1,
      startHour: 9,
      startMin: 30,
      evaluateQuotes: true,
      persistTradePlanOnFailedFiltersOrValidation: false,
      useDifferentWorkOrderFieldsOnExit: false,
      getAwayOffsetPctOnExit: 0.1,
      pctBetweenBidAskOnExit: 0.5,
      pctIncreasePerOrderAttemptOnExit: 0.1,
      //maxOptionSpreadPct: 0.05,
      //buyOrSellOption: "LONG",
      useDifferentWorkOrderFieldsOnTarget: false,
      getAwayOffsetPctOnTarget: 0.1,
      pctBetweenBidAskOnTarget: 0.5,
      pctIncreasePerOrderAttemptOnTarget: 0.1,
    }
  );
  return [top, dispatchTop];
}
